<template>
    <div>
    <button class="btn btn-sm btn-warning float-right" @click="handleAdd()"> + Add Level</button> <br/><br/>
    <a-table :columns="columns" :dataSource="dataSource" :pagination="dataSourcepagination" bordered>
        <template
            v-for="col in ['field_name', 'order_by']"
            :slot="col"
            slot-scope="text, record"
        >
            <div :key="col" v-if="col == 'field_name'">
            <a-select v-if="record.editable" style="width: 100%" placeholder="Select input type" @select="e => handleChange(e, record.key, col)">
                <a-select-option v-for="field_name in fieldName" :key="field_name.value" :value="field_name.value">{{field_name.name}}</a-select-option>
            </a-select>
            <template v-else>{{text}}</template
            >
            </div>

            <div :key="col" v-if="col == 'order_by'">
            <a-select v-if="record.editable" style="width: 100%" placeholder="Select input type" @select="e => handleChange(e, record.key, col)">
                <a-select-option v-for="order in orderBy" :key="order.value" :value="order.value">{{order.name}}</a-select-option>
            </a-select>
            <template v-else>{{text}}</template
            >
            </div>
        </template>
        <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
            <span v-if="record.editable">
                <a class="btn btn-sm btn-primary" style="color: white;" @click="() => save(record.key)">Save</a>
                <!-- <a style="color: white;" class="btn btn-sm btn-danger" @click="() => cancel(record.key, null)">Cancel</a> -->
            </span>
            <span v-else>
                <a style="color: white;" class="btn btn-sm btn-primary" @click="() => edit(record.key)">Edit</a>
                <a-popconfirm title="Are you sure you want to delete this field?" @confirm="() => deleteField(record, null)">
                <a style="color: white;" class="btn btn-sm btn-danger">Delete</a>
                </a-popconfirm>
            </span>
            </div>
        </template>
    </a-table>

    <div
        class="float-right"
        style="position: absolute; bottom: 20px; right: 20px"
        >
        <button
            class="btn btn-primary float-right"
            @click.prevent="saveSort()"
        >
            Apply
        </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SortDrawer',
        props: ['documentTypeCode'],
        data(){
            return {
                columns: [
                    {
                        title: 'Field Name',
                        dataIndex: 'field_name',
                        width: '25%',
                        scopedSlots: { customRender: 'field_name' },
                    },
                    {
                        title: 'Order By',
                        dataIndex: 'order_by',
                        width: '25%',
                        scopedSlots: { customRender: 'order_by' },
                    },
                    {
                        title: '',
                        dataIndex: 'operation',
                        width: '20%',
                        scopedSlots: { customRender: 'operation' },
                    },
                ],    
                dataSource: [],
                dataSourcepagination: {
                    defaultCurrent: 1,
                    current: 1,
                    onChange: (current) => {
                    this.dataSourcepagination.current = current;
                    },
                },
                orderBy: [{name: "Ascending", value: 'asc'},{name: "Descending", value: 'desc'}],
                fieldName: [
                    {name: "Line Number", value: "line_no"}, 
                    {name: "Stock Number", value:"supplier_stock_no"},
                    {name: "Barcode", value:"barcode"},
                ],
                component: {},
                completeAttributes: []
            }
            // end data
        },
        beforeMount(){
            if(this.documentTypeCode == "RECTRX" || this.documentTypeCode == "RELTRX")
            {
                this.fieldName.push({name: "Color", value: "color"}, 
                {name: "Size", value:"size"})
            }else{
                this.fieldName.push({name: "Description", value: "product_name"})
            }

            const docSortDrawerData = localStorage.getItem("documentTypeSort" + this.documentTypeCode);
            if(docSortDrawerData != undefined && docSortDrawerData != null && docSortDrawerData != "[]"){
                this.dataSource = JSON.parse(docSortDrawerData)
            }
        },
        methods: {
            saveSort(){
                this.$emit('saveSort', this.dataSource)
            },
            handleChange(value, key, column) {
                const newData = [...this.dataSource];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    this.dataSource = newData;
                }
            },
            handleAdd() {
                const { dataSource } = this;
                if(dataSource.length > 0){
                var ds = dataSource.slice().sort((a, b) => parseInt(a.key) - parseInt(b.key))
                this.count = ds[ds.length - 1].key + 1
                }else {
                this.count = 0
                }
                const newData = { key: this.count,  field_name: "", order_by: "", editable: true};
                let newDs = [...dataSource,newData];
                this.dataSource = newDs;
                var page = Math.ceil(this.dataSource.length / 10) || 1;
                this.dataSourcepagination.current = page;
            },
            edit(key) {
                const newData = [...this.dataSource];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    target.editable = true;
                    this.dataSource = newData;
                }
            },
            save(key) {
                const newData = [...this.dataSource];
                const defNewData = [...this.completeAttributes];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    if( (target.field_name == null || target.field_name == '') ||  (target.order_by == null || target.order_by == '')){
                    this.$message['error'](
                        "Cannot save. Null values."
                    );
                    }  else {
                    const dupCode = newData.filter(item => target.field_name === item.field_name).length;
                    const defDupName = defNewData.filter(item => target.field_name === item.field_name).length;
                    if(dupCode > 1 || defDupName > 0){
                    this.$message['error'](
                        "Cannot save. Duplicate value."
                    );
                    } else {
                    delete target.editable;
                    this.dataSource = newData;
                    Object.assign(
                        target
                    );
                    }
                }
                }
            },
            deleteField(record) {
                const dataSource = [...this.dataSource];
                this.dataSource = dataSource.filter(item => item.key !== record.key);
            },
        }
        // end methods
    }
</script>